import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";
// import { injectIntl } from "react-intl";
import { makeStyles } from '@material-ui/core';  
import Cookies from 'js-cookie';

import * as auth from "../_redux/authRedux";
import { verifyCode, login } from "../_redux/authCrud";
import "../../../../App.css";
import {Form} from "react-bootstrap";
// import { successResponse } from "../__mocks__/mockAuth";

const initialValues = {
    otp: ""
};
const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3, 6)
    },
    mt: {
        marginTop: '20px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    btnClr: {
        backgroundColor: "#f5823d",
        borderColor: "#f5823d",
        "&:hover": {
            backgroundColor: "#f5823d",
            color: "#ffff"
        },
        color: "#ffff"
    },
    note: {
        color: "#f5823d"
    },
    alertMsg: {
        color: 'red'
    }
}));
function VerifyCode(props) {
    // const { intl } = props;
    // const [isRequested, setIsRequested] = useState(false);
    const [responseStatus, setResponse] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resendLoad, setResendLoad] = useState(false);
    const [errorMsg, setMessage] = useState("");
    const OtpVerificationSchema = Yup.object().shape({
        otp: Yup.number()
            .required(
                // intl.formatMessage({
                //     id: "AUTH.VALIDATION.REQUIRED_FIELD",
                // })
            )
    });
    useEffect(() => {

    }, []);

    // const getInputClasses = (fieldname) => {
    //     if (formik.touched[fieldname] && formik.errors[fieldname]) {
    //         return "is-invalid";
    //     }

    //     if (formik.touched[fieldname] && !formik.errors[fieldname]) {
    //         return "is-valid";
    //     }

    //     return "";
    // };
    const enableMessage = () => {
        setResponse(true);
    }
    const enableLoading = () => {
        setLoading(true);
    };
    const disableLoading = () => {
        setLoading(false);
    };
    const classes = useStyles();
    const formik = useFormik({
        initialValues,
        validationSchema: OtpVerificationSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            enableLoading();
            verifyCode({ code: values.otp, email: props.history.location.state.email })
                .then((response) => {
                    disableLoading();
                    setSubmitting(false);
                    enableMessage();
                    setMessage(response.data.message);
                    if (response.data.status) {
                        // To do eula,lang,
                        //set token
                        // props.login(response.data.value);
                        const user = {
                            name: response.data.data['user-name'],
                            email: response.data.data.item
                            // role: response.data.data.role,
                            // phoneNumber: response.data.data.phoneNumber,
                            // countryCode: response.data.data.countryCode,
                            // preferredLang: response.data.value.preferredLang,
                        };
                        Cookies.set('accessToken', response.data.data.token);
                        props.login(user);
                    };
                })
                .catch((error) => {
                    disableLoading();
                    setSubmitting(false);
                    enableMessage();
                    setMessage(error.response.data.message);
                    // setStatus(
                    //     intl.formatMessage(
                    //         { id: "AUTH.VALIDATION.NOT_FOUND" },
                    //         { name: values.email }
                    //     )
                    // );
                });
        }
    });

    const resendOtp = () =>{
        setResendLoad(true);
        login(props.history.location.state.email,props.history.location.state.password)
        .then((response)=>{
            if (response.data.status) {
                setResendLoad(false);
                enableMessage();
                setMessage(response.data.message);
            }

        })
        .catch((error) => {
            setResendLoad(false);
            enableMessage();
            setMessage(error.response.data.message);
        })
    }

    return (
        // <div className="login-form login-signin" id="kt_login_signin_form">
        //     <Paper className={classes.root}>
        //         <div className="d-flex justify-content-center">
        //             <img
        //                 alt="Logo"
        //                 className="max-h-50px mb-7"
        //                 src={toAbsoluteUrl("/media/logos/gemflow.png")}
        //             />
        //         </div>
        //         <div className="text-muted font-weight-bold">
        //       Enter your email to reset your password
        //     </div>
        //         <div className={`text-center ${classes.note}`}>
        //             Enter Security Code
        //     </div>
        //         <form
        //             onSubmit={formik.handleSubmit}
        //             className={`form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp ${classes.mt}`}
        //         >
        //             {formik.status && (
        //                 <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
        //                     <div className="alert-text font-weight-bold">
        //                         {formik.status}
        //                     </div>
        //                 </div>
        //             )}
        //             <div className="form-group fv-plugins-icon-container">
        //                 <input
        //                     type="text"
        //                     placeholder="Enter code"
        //                     className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
        //                         "email"
        //                     )}`}
        //                     name="otp"
        //                     {...formik.getFieldProps("otp")}
        //                 />
        //                 {formik.touched.otp && formik.errors.otp ? (
        //                     <div className="fv-plugins-message-container">
        //                         <div className="fv-help-block">{formik.errors.otp}</div>
        //                     </div>
        //                 ) : null}
        //             </div>
        //             {/* <div className="form-group d-flex flex-wrap flex-center"> */}
        //             <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
        //                 <button
        //                     id="kt_login_forgot_submit"
        //                     type="submit"
        //                     className={`btn btn-lg btn-block ${classes.btnClr}`}
        //                     disabled={formik.isSubmitting}
        //                 >
        //                     <span> Submit</span>
        //                     {loading && <span className="ml-3 spinner spinner-white"></span>}
        //                 </button>
        //             </div>
        //             {responseStatus ? (<div className={`d-flex p-2 ${classes.alertMsg}`}>{errorMsg}</div>) : ''}
        //         </form>
        //     </Paper>
        //     {/*end::Form*/}
        // </div>

        <div>
            <div className="vertical-center outer">
            <div ></div>
            <div className="shadow-lg box">
                <div align="center">
                    <h3><b>Enter your authentication code</b></h3>
                    <p><b>We just sent you a temporary code to validate<br/>
                    your email address, check your inbox.</b></p>
                </div>
                <Form style={{marginTop:"10%"}} align="center">
                    <Form.Group controlId="formGroupEmail">
                        <Form.Control className="form-control" type="email" style={{border:"1px solid black"}} name="otp"
                            {...formik.getFieldProps("otp")} placeholder="Authentication code" autoComplete="off"/>
                            {formik.touched.otp && formik.errors.otp ? (
                            <div className="fv-plugins-message-container">
                                <div className="fv-help-block d-flex p-2">{formik.errors.otp}</div>
                            </div>
                        ) : null}
                    </Form.Group>
                </Form>
                <div style={{marginTop:"20%"}} align="center">
                    <div align="center"><p style={{cursor:"pointer"}} onClick={resendOtp}><u>didn,t receive code?<b>Resend</b></u>{resendLoad && <span className="ml-3 spinner spinner-dark"></span>}</p></div>
                    <div align="center" style={{cursor:"pointer",border:"1px solid black"}} className="btn btn-lg btn-block vertical-center" onClick={formik.handleSubmit}><span style={{cursor:"pointer"}}><b>Sign in</b></span>{loading && <span className="ml-3 spinner spinner-dark"></span>}</div>
                    {responseStatus ? (<div className={`d-flex p-2 ${classes.alertMsg}`}>{errorMsg}</div>) : ''}
                </div>
            </div>
            <div ></div>
            </div>
        </div>
    );
}

// export default injectIntl(connect(null, auth.actions)(VerifyCode));
export default (connect(null, auth.actions)(VerifyCode));
